var QueryStatus;

(function (QueryStatus) {
  QueryStatus["uninitialized"] = "uninitialized";
  QueryStatus["pending"] = "pending";
  QueryStatus["fulfilled"] = "fulfilled";
  QueryStatus["rejected"] = "rejected";
})(QueryStatus || (QueryStatus = {}));

function getRequestStatusFlags(status) {
  return {
    status,
    isUninitialized: status === QueryStatus.uninitialized,
    isLoading: status === QueryStatus.pending,
    isSuccess: status === QueryStatus.fulfilled,
    isError: status === QueryStatus.rejected
  };
}

export { QueryStatus, getRequestStatusFlags };
//# sourceMappingURL=apiState.js.map
